<template>
    <layout-basic>
        <v-container grid-list-md text-xs-center>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card flat>
                        <v-card-text class="px-0">
                            <v-btn color="primary">Back to Course Manager</v-btn>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-card flat>
                        <v-card-actions>
                            <h3>Manage Users</h3>
                            <v-spacer></v-spacer>
                            <v-btn v-if="!userButtonDisabled" disabled color="error">
                                Remove
                            </v-btn>
                            <v-btn v-else color="error">Remove</v-btn>
                            <v-btn v-if="!userButtonDisabled" disabled color="error">
                                Update Deadline
                            </v-btn>
                            <v-btn v-else color="primary">Update Deadline</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <user-list :id="id" :extended-view="true" type="manage"></user-list>
    </layout-basic>
</template>

<script>
    import LayoutBasic from "@/layouts/Dashboard";
    import UserList from "@/components/admin/global/Userlist";
    export default {
        components: {
            LayoutBasic,
            UserList
        },
        data() {
            return {
                selectedUsers: [],
                selectedUserCount: 0,
                deadlineSet: false,
                loading: false,
                id: this.$route.params.id,
                userButtonDisabled: false
            };
        },
        methods: {
            buttonState() {
                if (this.selectedUserCount > 0) {
                    this.userButtonDisabled = false;
                } else {
                    this.userButtonDisabled = true;
                }
            }
        }
    };
</script>
